import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  INotificationItem,
  INotificationsResponse,
  INotificationState,
} from "../@types/notifications";

const initialState: INotificationState = {
  notifications: [],
  notification: null,
  total: 0,
  current_page: 1,
  last_page: 1,
  loading: false,
  show: false,
  update: false,
};

export const notification = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotifications: (
      state,
      action: PayloadAction<INotificationsResponse>
    ) => {
      state.notifications = action.payload.data.map((n) => ({
        ...n,
        seen: String(n.seen) === "1", // <-- clean, safe, no TS error
      }));

      state.current_page = action.payload.current_page;
      state.last_page = action.payload.last_page;
      state.total = action.payload.total;
    },
    setNotification: (state, action: PayloadAction<INotificationItem>) => {
      state.notification = action.payload;
    },

    setNotificationSeen: (state, action: PayloadAction<string | number>) => {
      const id = action.payload;

      // update list item
      state.notifications = state.notifications.map((item: INotificationItem) =>
        item.id === id ? { ...item, seen: "1" } : item
      );

      // update opened notification if same ID
      if (state.notification?.id === id) {
        state.notification = { ...state.notification, seen: "1" };
      }
    },
    setLoading: (state) => {
      state.loading = !state.loading;
    },

    setShow: (state) => {
      state.show = !state.show;
    },

    setUpdate: (state) => {
      state.update = !state.update;
    },
  },
});

export const {
  setNotifications,
  setNotification,
  setLoading,
  setShow,
  setNotificationSeen,
  setUpdate,
} = notification.actions;

export default notification.reducer;
